import { FormBase } from 'core/components';

export default class BulkPrintHistoryForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'name',
					label: 'FULFILLMENTORDER.BULKPRINT.FORM.NAME',
					rules: 'required|string',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/BulkPrintHistoryForm.js